import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";

export default function S12TopMenu({ slug, activeMenu }) {
  const [studentInfo, setStudentInfo] = useState(0);

  async function GetData() {
    const info = await getIdData(slug);
    setStudentInfo(info[0].class);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="breadcrumb-bar breadcrumb-bar-info mb-2 sticky-top">
      <div className="container-fluid text-center">
        <div className="d-flex justify-content-between flex-wrap">
          <div>
            <h6>Planning Room</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                <div >
                  <Link
                    to={`/student12/student-schedulelist`}
                    className={
                      activeMenu === "Schedule"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Schedule
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-tasklist`}
                    className={
                      activeMenu === "Agenda"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Agenda
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-curriculum-table`}
                    className={
                      activeMenu === "Timeline"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Timeline
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6>College</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                <div >
                  <Link
                    to={`/student12/student-collegelist`}
                    className={
                      activeMenu === "List"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    List
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-deadline`}
                    className={
                      activeMenu === "Deadline"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Deadlines
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-finaid`}
                    className={
                      activeMenu === "Fin. Aid"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Fin. Aid
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6>Writings</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                <div >
                  <Link
                    to={`/student12/student-activitiesandawards`}
                    className={
                      activeMenu === "Activities/Awards"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Activities/Awards
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-mainessay`}
                    className={
                      activeMenu === "Main Essay"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Main Essay
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-supplementalessay`}
                    className={
                      activeMenu === "Supplementals"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Supplementals
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-additionalinfo`}
                    className={
                      activeMenu === "Additional Info"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Additional Info
                  </Link>
                </div>
                <div >
                  <Link
                    to={`/student12/student-bragsheet`}
                    className={
                      activeMenu === "Brag Sheet"
                        ? "tag text-danger bg-info-subtle border-0 text-decoration-underline fw-bold"
                        : "tag text-danger bg-info-subtle border-0 text-decoration-none"
                    }
                  >
                    Brag Sheet
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
